<template>
  <div class="survey-job-list-redirect"></div>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import { ACCOUNT_TYPE } from '@/constant/common'
import { deviceType } from '@/utils/common'

const CUSTOM_FILTER_PREFIX = 'custom_filter_'

const OPTION_TYPE_QUERY_MAP = {
  city: 'city',
  role_type: 'rt'
}

const OPTION_TYPE_DEFAULT_FILTER_NAME_MAP = {
  city: 'Location',
  role_type: 'Role Type'
}

export default {
  computed: {
    companyId () {
      return this.$route.params.companyId
    }
  },
  created () {
    this.redirect()
  },
  methods: {
    ...mapActions('account', ['getSessionAccountInfo']),
    ...mapActions('company', ['getCompanyBaseInfo', 'getCompanyCustomJobFilterList']),
    ...mapActions('survey', ['getSurveyQuestion']),
    isValidCandidateAccount (account) {
      if (!account || !account.id) {
        return false
      }
      if (account.type === ACCOUNT_TYPE.CANDIDATE) {
        return true
      }
      const employeeStatus = account.employee && account.employee.status
      return employeeStatus === '2' || employeeStatus === 2
    },
    redirectToCandidateRegister () {
      this.$router.replace({
        path: `/passport/${ACCOUNT_TYPE.CANDIDATE}/register`,
        query: {
          ...this.$route.query,
          back: this.$route.fullPath,
          company_id: this.companyId
        }
      })
    },
    redirectToSurvey () {
      this.$router.push({
        path: `/recruiting/company/${this.companyId}/survey`,
        query: this.$route.query
      })
    },
    redirectToJobList (filterParams = {}) {
      const path = deviceType.isPc
        ? `/recruiting/company/${this.companyId}/job-list`
        : `/mobile-web-more-jobs/${this.companyId}`
      this.$router.replace({
        path,
        query: {
          ...this.$route.query,
          aj_source: 'C_WECHAT_JOBLIST',
          aj_code: 'New_Job_Notification'
        },
        hash: this.buildJobListHash(filterParams)
      })
    },
    async redirect () {
      this.$eventBus.$emit('showLoading', true)
      try {
        const account = await this.getSessionAccountInfo()
        if (!this.isValidCandidateAccount(account)) {
          this.redirectToCandidateRegister()
          return
        }

        const companyInfo = await this.getCompanyBaseInfo({
          id: this.companyId,
          params: {
            simple_info: 1
          }
        })
        const preferenceSurvey = companyInfo && companyInfo.preference_survey
        if (!preferenceSurvey || !preferenceSurvey.show_entrance) {
          this.redirectToJobList()
          return
        }
        if (!preferenceSurvey.has_answered) {
          this.redirectToSurvey()
          return
        }

        const [surveyQuestionInfo, companyJobFilterList] = await Promise.all([
          this.getSurveyQuestion(this.companyId),
          this.getCompanyCustomJobFilterList({
            companyId: this.companyId,
            params: {}
          })
        ])
        const filterParams = this.buildSurveyFilterParams(
          surveyQuestionInfo && surveyQuestionInfo.questions,
          this.getCompanyJobFilterConfig(companyJobFilterList)
        )
        this.redirectToJobList(filterParams)
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    },
    appendFilterParam (params, key, value) {
      if (!key || value === null || value === undefined || value === '') {
        return
      }
      const values = _.chain(`${value}`).split(',').map(item => item.trim()).filter().value()
      if (!values.length) {
        return
      }
      params[key] = _.uniq([...(params[key] || []), ...values])
    },
    getCompanyJobFilterConfig (filterList) {
      return {
        customFilterIds: _.chain(filterList)
          .filter(filter => !filter.is_default)
          .map(filter => _.get(filter, 'id'))
          .filter()
          .map(filterId => `${filterId}`)
          .value(),
        defaultFilterNames: _.chain(filterList)
          .filter({ is_default: true })
          .map('name')
          .filter()
          .value()
      }
    },
    buildSurveyFilterParams (questions, jobFilterConfig = {}) {
      const params = {}
      const customFilterIds = jobFilterConfig.customFilterIds || []
      const defaultFilterNames = jobFilterConfig.defaultFilterNames || []
      _.forEach(questions, question => {
        if (!question || question.question_type === 'text') {
          return
        }
        const optionType = question.option_type
        if (optionType === 'custom' || optionType === 'job_type') {
          return
        }
        if (optionType === 'filter') {
          if (!_.includes(customFilterIds, `${question.filter}`)) {
            return
          }
          this.appendFilterParam(params, `${CUSTOM_FILTER_PREFIX}${question.filter}`, question.result)
          return
        }
        const defaultFilterName = OPTION_TYPE_DEFAULT_FILTER_NAME_MAP[optionType]
        if (defaultFilterName && !_.includes(defaultFilterNames, defaultFilterName)) {
          return
        }
        this.appendFilterParam(params, OPTION_TYPE_QUERY_MAP[optionType], question.result)
      })
      return _.mapValues(params, values => values.join(','))
    },
    buildJobListHash (params) {
      const parts = [
        'page=1',
        'page_size=10'
      ]
      _.forEach(params, (value, key) => {
        if (value !== null && value !== undefined && value !== '') {
          parts.push(`${key}=${encodeURIComponent(value)}`)
        }
      })
      return parts.join('&')
    }
  }
}
</script>
